<template>
  <div class="search-tab">
    <el-form size="mini" label-width="80px" label-position="left">
      <el-form-item label="MMSI">
        <el-input v-model="form.mmsi" maxlength="9" placeholder="输入MMSI" />
        <el-popover
          v-model="historycallstate"
          placement="right"
          width="650"
          trigger="click"
          :disabled="!mmsivalid"
          popper-class="search-tab-popover"
        >
          <el-card
            v-loading="isloading"
            class="search-tab-card"
            :body-style="{ padding: '8px' }"
          >
            <div slot="header">{{ form.mmsi }} 的历史查询记录</div>

            <el-table
              :data="historycalllist"
              row-key="id"
              max-height="400px"
              size="mini"
            >
              <el-table-column prop="btm" label="开始时间" width="150px" />
              <el-table-column prop="etm" label="结束时间" width="150px" />
              <el-table-column prop="caller" label="用户名" width="120px" />
              <el-table-column prop="otime" label="查询时间" width="150px" />
              <el-table-column label="操作" width="60px">
                <el-button
                  slot-scope="scope"
                  type="text"
                  size="mini"
                  @click="lookHistory(scope.row)"
                >
                  查看
                </el-button>
              </el-table-column>
            </el-table>
          </el-card>
          <el-button
            v-show="mmsivalid"
            slot="reference"
            type="text"
            :disabled="isloading || historycallstate"
            @click="historyCall"
          >
            查看最近调用
          </el-button>
        </el-popover>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker
          v-model="range"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </el-form-item>
      <el-form-item style="text-align: right">
        <el-button
          type="primary"
          :loading="isloading"
          :disabled="historycallstate"
          @click="queryvoyage"
        >
          查询
        </el-button>
      </el-form-item>
    </el-form>

    <point-control
      v-loading="isloading"
      :voyageinfo="voyageinfo"
      :groups="colorgroups"
      @selection="onselection"
      @clearvoyage="clearvoyage0"
      @row-click="onrowclick"
    />
  </div>
</template>

<script>
import request from '@/mixins/request.js'
import PointControl from './PointControl.vue'
import { timediff, keyCmp } from './maputil'

export default {
  components: {
    PointControl,
  },

  mixins: [request],

  data() {
    return {
      form: {
        mmsi: '',
        btime: '',
        etime: '',
      },

      isloading: false,

      voyageinfo: {},

      selections: [],

      activate: true,

      historycalllist: [],

      historycallstate: false,
    }
  },

  computed: {
    range: {
      get() {
        return [this.form.btime, this.form.etime]
      },

      set(value) {
        value = value || []
        this.form.btime = value[0] || ''
        this.form.etime = value[1] || ''
      },
    },

    trajectories() {
      if (!this.activate) {
        return []
      }

      const colors = this.$store.state.app.maptheme || []

      const selections = [...(this.selections || [])]
      selections.sort((a, b) => keyCmp(a.key, b.key))

      const chunks = []

      let lasttime

      for (let i = 0, j = selections.length, k = 0; i < j; i++) {
        const curr = selections[i]
        if (lasttime) {
          if (timediff(lasttime, curr.key) > 1) {
            k++
          }
        }
        const pointChunk =
          chunks[k] ||
          (chunks[k] = {
            points: [],
            colorIndex: k % colors.length,
            color: colors[k % colors.length].color0,
            keys: [],
          })

        curr.trajectories.forEach(it => {
          if (!it.invalid) {
            pointChunk.points.push(it)
          }
        })

        pointChunk.keys.push(curr.key)

        lasttime = curr.key
      }

      return chunks
    },

    colorgroups() {
      const trajectories = this.trajectories || []
      return trajectories.map(chunk => ({
        index: chunk.colorIndex,
        keys: [...chunk.keys],
      }))
    },

    mmsivalid() {
      return /^\d{9}$/.test(this.form.mmsi)
    },
  },

  watch: {
    trajectories() {
      this.$emit('trajectories', this.trajectories)
    },
  },

  mounted() {
    this.$on('deactivate', () => (this.activate = false))

    this.$on('activate', () => {
      setTimeout(() => {
        this.activate = true
      }, 50)
    })
  },

  methods: {
    lookHistory(row) {
      this.historycallstate = false
      this.lookup(this.form.mmsi, row.btm, row.etm)
    },

    async queryvoyage() {
      if (!this.mmsivalid) {
        return this.$message.error('mmsi 格式错误')
      }

      if (!this.form.btime || !this.form.etime) {
        return this.$message.error('查询时间不能为空')
      }

      this.isloading = true
      this.voyageinfo = {}

      try {
        const resp = await this.$api.get('/schedules/voyageops/queryvoyage', {
          params: this.form,
        })

        if (resp.data.status !== 1) {
          return this.$message.error(resp.data.message || '查询错误')
        }

        this.voyageinfo = resp.data.content || {}
      } finally {
        this.isloading = false
      }
    },

    async clearvoyage0(keys) {
      this.isloading = true
      try {
        const resp = await this.clearvoyage(keys, this.form.mmsi)
        if (resp.data.status === 1) {
          // this.$message.success('清除成功!');
          await this.queryvoyage()
        }
      } finally {
        this.isloading = false
      }
    },

    clearvoyage(keys, mmsi) {
      return this.$api.post('/schedules/voyageops/clearvoyage', keys, {
        params: {
          mmsi: mmsi,
        },
      })
    },

    onselection(chunks) {
      // console.log(chunks);
      this.selections = chunks
    },

    lookup(mmsi, begin, end) {
      console.log(mmsi, begin, end)
      this.form.mmsi = mmsi
      this.form.btime = begin
      this.form.etime = end
      return this.queryvoyage()
    },

    onrowclick(row) {
      this.$emit('center', row.trajectories[0])
    },

    async historyCall() {
      const mmsi = this.form.mmsi

      this.isloading = true

      this.historycalllist = []

      try {
        const resp = await this.$api.get('/schedules/voyageops/historycall', {
          params: {
            mmsi,
          },
        })

        if (resp.data.status !== 1) {
          return this.$message.error(resp.data.message || '查询错误')
        }

        this.historycalllist = resp.data.content || []
      } finally {
        this.isloading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search-tab {
  .el-input__inner {
    width: 100%;
  }
}
</style>

<style lang="scss">
.search-tab-popover {
  max-height: inherit;
}
</style>
